import gql from 'graphql-tag';

const MUTATION_RESEND_VERIFICATION_CODE = gql`
  mutation resendVerificationCode($userId: ID!) {
    resendVerificationCode(userId: $userId) {
      isSuccess
      message
    }
  }
`;

export default MUTATION_RESEND_VERIFICATION_CODE;
